module.exports = __webpack_public_path__ + "img/69f2843.png";